import { Auth } from "aws-amplify";
import { db } from "@/lib/indexeddb";
import { clearStorageKeepingLocale } from "@/lib/utils/i18n/locale";

export async function logout(): Promise<void> {
  const result = await Auth.signOut();
  if (!result) {
    clearStorageKeepingLocale();
  }
  window.sessionStorage.removeItem("vuex");
  db.delete();
  window.location.href = "/";
}
